import React, { FunctionComponent } from 'react'
import { Button, Divider, Heading, Icon, Text } from '@afterpaytouch/core'
import { useTranslation } from '../../../../utils/convergence'
import styles from './styles.module.css'
import Image from 'next/image'
import { BASE_PATH } from '../../../../env'

const TEST_NAMESPACE = 'apple-paylater-education'

export interface CardEducationProps {
  onContinue?: () => void
}

interface Feature {
  icon: 'Globe' | 'Card' | 'PayInFour'
  titleKey: string
  descriptionKey: string
}

const features: Feature[] = [
  { icon: 'Card', titleKey: 'features.planPurchase.title', descriptionKey: 'features.planPurchase.description' },
  { icon: 'PayInFour', titleKey: 'features.flexiblePlans.title', descriptionKey: 'features.flexiblePlans.description' },
  { icon: 'Globe', titleKey: 'features.shopOnline.title', descriptionKey: 'features.shopOnline.description' },
]

export const CardEducation: FunctionComponent<CardEducationProps> = ({ onContinue }) => {
  const { t } = useTranslation(['cardEducation'])
  const cardImagePath = [BASE_PATH, 'images', t('heroImage')].join('/')

  const handleContinue = (): void => {
    onContinue?.()
  }

  return (
    <div className={styles.container}>
      <Image src={cardImagePath} alt={t('heroImageAlt')} width={374} height={374} data-testid={`${TEST_NAMESPACE}-hero-image`} />
      <Heading testNameSpace={TEST_NAMESPACE} size='XXXL'>
        {t('heading')}
      </Heading>
      <Text testNameSpace={TEST_NAMESPACE} size='S'>
        {t('description')}
      </Text>

      <div className={styles.featuresContainer}>
        {features.map((feature) => (
          <div key={feature.titleKey} className={styles.featureItem}>
            <Icon name={feature.icon} size='Medium' />
            <div>
              <Text testNameSpace={TEST_NAMESPACE} bold>
                {t(feature.titleKey)}
              </Text>
              <Text testNameSpace={TEST_NAMESPACE} size='S'>
                {t(feature.descriptionKey)}
              </Text>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footerContainer}>
        <Divider kind='Hairline' margin='Regular' />
        <Button.Primary testNameSpace={TEST_NAMESPACE} onClick={handleContinue} padding='Fluid'>
          {t('getNewCard')}
        </Button.Primary>
      </div>
    </div>
  )
}
